module.exports = __webpack_public_path__ + "img/kimsa_logo.fffebb39.png";